/**
 * armageddon-event.js
 * Battle for Armageddon — Shopify Event Landing Page
 * Upload to: Assets/armageddon-event.js
 */

(function () {
  'use strict';

  /* ═══════════════════════════════════════════
     1. READ DATA FROM LIQUID BRIDGE
  ═══════════════════════════════════════════ */
  const dataEl = document.getElementById('armageddon-data');
  if (!dataEl) return;

  // Safe parsers: fall back only when value is missing/NaN, NOT when it is 0
  function safeInt(val, fallback) {
    var n = parseInt(val, 10);
    return isNaN(n) ? fallback : n;
  }
  function safeFloat(val, fallback) {
    var n = parseFloat(val);
    return isNaN(n) ? fallback : n;
  }

  const DATA = {
    baTroops:    Math.max(safeInt(dataEl.dataset.baTroops,    80000),  0),
    orkTroops:   Math.max(safeInt(dataEl.dataset.orkTroops,   125000), 0),
    baMax:       safeInt(dataEl.dataset.baMax,       80000),
    orkMax:      safeInt(dataEl.dataset.orkMax,      125000),
    baDecimated: safeInt(dataEl.dataset.baDecimated, 0),
    orkDecimated:safeInt(dataEl.dataset.orkDecimated,0),
    baPct:       Math.max(safeFloat(dataEl.dataset.baPct,  100), 0),
    orkPct:      Math.max(safeFloat(dataEl.dataset.orkPct, 100), 0),
    myBa:        safeInt(dataEl.dataset.myBa,  0),
    myOrk:       safeInt(dataEl.dataset.myOrk, 0),
  };

  /* ═══════════════════════════════════════════
     2. ANIMATED COUNTER
     Counts from 0 to target with cubic ease-out
  ═══════════════════════════════════════════ */
  function animateCounter(el, target, duration) {
    if (!el) return;
    duration = duration || 1800;
    var start = performance.now();
    var startVal = parseInt(el.textContent.replace(/,/g, '')) || 0;

    function update(now) {
      var t = Math.min((now - start) / duration, 1);
      var ease = 1 - Math.pow(1 - t, 3);
      var val = Math.round(startVal + (target - startVal) * ease);
      el.textContent = val.toLocaleString();
      if (t < 1) requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }

  /* ═══════════════════════════════════════════
     3. SET PROGRESS BARS
  ═══════════════════════════════════════════ */
  function setProgressBars() {
    var baBar  = document.getElementById('ba-progress');
    var orkBar = document.getElementById('ork-progress');
    if (baBar)  baBar.style.width  = DATA.baPct  + '%';
    if (orkBar) orkBar.style.width = DATA.orkPct + '%';
  }

  /* ═══════════════════════════════════════════
     3b. EVENT-END DETECTION & BANNERS
  ═══════════════════════════════════════════ */
  var eventEnded = false;

  function applyResultBanners(baWon) {
    // Remove any server-rendered banners first to avoid duplicates
    document.querySelectorAll('.faction-result-banner').forEach(function (el) { el.remove(); });

    var baCard  = document.querySelector('.faction-card.blood-angels');
    var orkCard = document.querySelector('.faction-card.orks');

    function makeBanner(type, text) {
      var el = document.createElement('div');
      el.className = 'faction-result-banner ' + type;
      el.textContent = text;
      return el;
    }

    if (baCard) {
      baCard.classList.add('event-ended');
      baCard.insertBefore(makeBanner(baWon ? 'victory-banner' : 'defeat-banner', baWon ? 'Victory' : 'Defeat'), baCard.firstChild);
    }
    if (orkCard) {
      orkCard.classList.add('event-ended');
      orkCard.insertBefore(makeBanner(baWon ? 'defeat-banner' : 'victory-banner', baWon ? 'Defeat' : 'Victory'), orkCard.firstChild);
    }
  }

  function checkEventEnd() {
    if (eventEnded) return true;
    if (DATA.baTroops <= 0 || DATA.orkTroops <= 0) {
      eventEnded = true;
      // Clamp both values to 0 floor
      DATA.baTroops  = Math.max(DATA.baTroops,  0);
      DATA.orkTroops = Math.max(DATA.orkTroops, 0);
      var baWon = DATA.orkTroops <= 0; // BA wins when Orks hit 0
      applyResultBanners(baWon);
      return true;
    }
    return false;
  }

  /* ═══════════════════════════════════════════
     4. INITIALISE COUNTERS
  ═══════════════════════════════════════════ */
  function initCounters() {
    // If event already over on load, show 0 for the defeated side — no animation
    if (checkEventEnd()) {
      var baEl  = document.getElementById('ba-count');
      var orkEl = document.getElementById('ork-count');
      if (baEl)  baEl.textContent  = DATA.baTroops.toLocaleString();
      if (orkEl) orkEl.textContent = DATA.orkTroops.toLocaleString();
      animateCounter(document.getElementById('ba-decimated'),    DATA.baDecimated);
      animateCounter(document.getElementById('ork-decimated'),   DATA.orkDecimated);
      animateCounter(document.getElementById('ba-contrib-count'),DATA.myBa);
      animateCounter(document.getElementById('ork-contrib-count'),DATA.myOrk);
      return;
    }
    setTimeout(function () {
      animateCounter(document.getElementById('ba-count'),        DATA.baTroops);
      animateCounter(document.getElementById('ork-count'),       DATA.orkTroops);
      animateCounter(document.getElementById('ba-decimated'),    DATA.baDecimated);
      animateCounter(document.getElementById('ork-decimated'),   DATA.orkDecimated);
      animateCounter(document.getElementById('ba-contrib-count'),DATA.myBa);
      animateCounter(document.getElementById('ork-contrib-count'),DATA.myOrk);
    }, 300);
  }

  /* ═══════════════════════════════════════════
     5. SCROLL FADE-IN
     IntersectionObserver on .fade-in elements
  ═══════════════════════════════════════════ */
  function initScrollFade() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: show all immediately
      document.querySelectorAll('.fade-in').forEach(function (el) {
        el.classList.add('visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.fade-in').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ═══════════════════════════════════════════
     6. LIVE POLLING
     Fetches updated tally from a Shopify proxy
     endpoint every 60 minutes.
     
     TO IMPLEMENT:
     - Create a Shopify app proxy at /apps/armageddon
     - Proxy should return JSON:
       {
         "ba_troops": 88423,
         "ork_troops": 182111,
         "ba_decimated": 1577,
         "ork_decimated": 7889,
         "ba_pct": 98.2,
         "ork_pct": 95.8
       }
  ═══════════════════════════════════════════ */
  var POLL_INTERVAL = 3600000; // 1 hour in ms
  var PROXY_URL = '/apps/armageddon/tallies'; // Update this to your proxy URL

  function updateTallyDOM(data) {
    // Ignore poll updates once the event has ended
    if (eventEnded) return;

    DATA.baTroops    = Math.max(data.ba_troops   || 0, 0);
    DATA.orkTroops   = Math.max(data.ork_troops  || 0, 0);
    DATA.baDecimated = data.ba_decimated || 0;
    DATA.orkDecimated= data.ork_decimated|| 0;
    DATA.baPct       = data.ba_pct  || 0;
    DATA.orkPct      = data.ork_pct || 0;

    // Check end condition before animating
    if (checkEventEnd()) return;

    var baEl     = document.getElementById('ba-count');
    var orkEl    = document.getElementById('ork-count');
    var baDecEl  = document.getElementById('ba-decimated');
    var orkDecEl = document.getElementById('ork-decimated');
    var baBar    = document.getElementById('ba-progress');
    var orkBar   = document.getElementById('ork-progress');

    if (baEl)     animateCounter(baEl,     DATA.baTroops,     1200);
    if (orkEl)    animateCounter(orkEl,    DATA.orkTroops,    1200);
    if (baDecEl)  animateCounter(baDecEl,  DATA.baDecimated,  1200);
    if (orkDecEl) animateCounter(orkDecEl, DATA.orkDecimated, 1200);
    if (baBar)    baBar.style.width  = DATA.baPct  + '%';
    if (orkBar)   orkBar.style.width = DATA.orkPct + '%';
  }

  function fetchTroopCounts() {
    if (eventEnded) return;
    fetch(PROXY_URL)
      .then(function (res) {
        if (!res.ok) throw new Error('Network response not ok');
        return res.json();
      })
      .then(function (data) {
        updateTallyDOM(data);
      })
      .catch(function (err) {
        console.warn('[Armageddon] Could not fetch live tally:', err);
      });
  }

  function initPolling() {
    if (PROXY_URL.indexOf('YOUR_PROXY') !== -1) return;
    if (eventEnded) return;
    setInterval(function () {
      if (!eventEnded) fetchTroopCounts();
    }, POLL_INTERVAL);
  }

  /* ═══════════════════════════════════════════
     7. SMOOTH SCROLL FOR STICKY NAV
     Handles anchor links in sticky bottom nav
  ═══════════════════════════════════════════ */
  function initStickyNav() {
    var navLinks = document.querySelectorAll('.sticky-nav a');

    // Smooth scroll with sticky-nav height offset
    navLinks.forEach(function (link) {
      if (!link.getAttribute('href') || link.getAttribute('href')[0] !== '#') return;
      link.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        var offset = target.getBoundingClientRect().top + window.scrollY - 20;
        window.scrollTo({ top: offset, behavior: 'smooth' });
      });
    });

    // Active section highlight — fires when a section's top edge
    // enters the upper 30% of the viewport (rootMargin trick).
    // Using a CSS class so transitions in the stylesheet apply cleanly.
    function setActive(id) {
      navLinks.forEach(function (link) {
        link.classList.toggle('nav-active', link.getAttribute('href') === '#' + id);
      });
    }

    var sections = ['war-tally', 'how-it-works', 'discounts', 'rewards'];

    if (!('IntersectionObserver' in window)) return;

    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setActive(entry.target.getAttribute('id'));
        }
      });
    }, {
      // Section is "active" when its top edge is within the top 30% of viewport
      rootMargin: '-10% 0px -65% 0px',
      threshold: 0
    });

    sections.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) sectionObserver.observe(el);
    });
  }

  /* ═══════════════════════════════════════════
     8. INIT — RUN ON DOM READY
  ═══════════════════════════════════════════ */
  function init() {
    setProgressBars();
    initCounters();
    initScrollFade();
    initStickyNav();
    initPolling();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
